/**
 * Parse a ticket/dispute message: extract inline file IDs from markdown links and clean the displayed text.
 *
 * @param {string} content - The raw message content
 * @returns {{ text: string, fileIds: number[], resultCode: string }}
 */
export function parseMessage(content) {
  if (!content) return { text: '', fileIds: [], resultCode: '' };
  const ids = [];
  const re = /\(\/api\/files\/(\d+)(?:\?[^)]*)?\)/g;
  let m;
  while ((m = re.exec(content)) !== null) {
    ids.push(Number(m[1]));
  }
  let text = content.replace(/\[[^\]]*\]\(\/api\/files\/\d+(?:\?[^)]*)?\)/g, '').trim();
  let resultCode = '';
  text = text.replace(/^\[(RESOLVED|REJECTED|OK|REJECT|PARTIAL)\]\s*/i, (_, code) => {
    const normalized = String(code || '').toUpperCase();
    if (normalized === 'OK') resultCode = 'RESOLVED';
    else if (normalized === 'REJECT') resultCode = 'REJECTED';
    else resultCode = normalized;
    return '';
  }).trim();
  text = text.replace(/\n{3,}/g, '\n\n').trim();
  return { text, fileIds: ids.filter((x) => !!x), resultCode };
}
